import ArtistPage from './ArtistPage';

export default ArtistPage;
